/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Region } from '../../models/region';

export interface GetRegions$Params {
   /**
    * Decide active or not region
    */
   active?: boolean;

   /**
    * Decide extract region with polygon or not
    */
   polygon?: boolean;
}

export function getRegions(
   http: HttpClient,
   rootUrl: string,
   params?: GetRegions$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Region>> {
   const rb = new RequestBuilder(rootUrl, getRegions.PATH, 'get');
   if (params) {
      rb.query('active', params.active, {});
      rb.query('polygon', params.polygon, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Region>;
      })
   );
}

getRegions.PATH = '/api/weather/region';
